import './testimonials.scss';
import Swiper from 'swiper';
import { Navigation, Controller } from 'swiper/modules';

const initSlider = () => {
  Swiper.use([Navigation, Controller]);

  let logoSlider = new Swiper('.b-testimonials__slider-logo', {
    slidesPerView: 1,
    slidesPerGroup: 1,
    spaceBetween: 80,
    centeredSlides: true,
    slideToClickedSlide: true,

    breakpoints: {
      1024: {
        slidesPerView: 3,
      },
    },
  });

  let quoteSlider = new Swiper('.b-testimonials__slider', {
    slidesPerView: 1,
    spaceBetween: 64,

    navigation: {
      nextEl: '.b-testimonials__slider .next',
      prevEl: '.b-testimonials__slider .prev',
      disabledClass: 'disabled',
    },
  });

  quoteSlider.controller.control = logoSlider;
  logoSlider.controller.control = quoteSlider;
};

document.addEventListener(
  'DOMContentLoaded',
  async function () {
    initSlider();
  },
  { once: true }
);
